import { authFetch } from "../utils/AuthFetch";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:3000/api';

// const getAccessToken = (): string => {
//   const token = localStorage.getItem('user_token');
//   if (!token) {
//     alert('로그인이 필요합니다.');
//     throw new Error('No access token');
//   }
//   return token;
// };

// // 2. refresh token으로 access token 재발급
// export const refreshAccessToken = async (): Promise<string> => {
//   const refreshToken = localStorage.getItem('refresh_token');
//   if (!refreshToken) {
//     alert('로그인이 필요합니다.');
//     throw new Error('No refresh token');
//   }

//   const res = await fetch(`${API_BASE_URL}/user/auth/renew_session`, {
//     method: 'POST',
//     headers: { 'Content-Type': 'application/json' },
//     body: JSON.stringify({ refresh_token: refreshToken }),
//   });

//   if (!res.ok) {
//     alert('세션이 만료되었습니다. 다시 로그인 해주세요.');
//     localStorage.removeItem('user_token');
//     localStorage.removeItem('refresh_token');
//     window.location.href = '/login';
//     throw new Error('Token refresh failed');
//   }

//   const data = await res.json();
//   localStorage.setItem('user_token', data.body.access_token);
//   if (data.body.refresh_token) {
//     localStorage.setItem('refresh_token', data.body.refresh_token);
//   }
//   return data.body.access_token;
// };

// // 3. 인증 + 401 재시도 wrapper
// const fetchWithAuthRetry = async (input: RequestInfo, init?: RequestInit, retry = true): Promise<Response> => {
//   let token = getAccessToken();
//   let response = await fetch(input, {
//     ...init,
//     headers: {
//       ...init?.headers,
//       Authorization: `Bearer ${token}`,
//     },
//   });

//   if (response.status === 401 && retry) {
//     // access token 만료 → refresh 후 재시도
//     token = await refreshAccessToken();
//     response = await fetch(input, {
//       ...init,
//       headers: {
//         ...init?.headers,
//         Authorization: `Bearer ${token}`,
//       },
//     });
//   }

//   return response;
// };

export const updateSpace = async (spaceId: string, formData: FormData) => {
  const response = await authFetch(`${API_BASE_URL}/space/spaces/${spaceId}`, {
    method: 'PATCH',
    body: formData,
  });

  if (!response.ok) {
    const errorData = await response.json();
    throw new Error(errorData.message || `Failed to update space: ${response.status}`);
  }

  return response;
}

export const updateSpaceData = async (spaceId: number, dto: any) => {
  const token = localStorage.getItem('user_token');
  if (!token) throw new Error('Token is missing. Please login.');

  // dto가 FormData라면 모든 값 확인
  if (dto instanceof FormData) {
    for (const [key, value] of dto.entries()) {
      console.log(key, value); // FormData에 뭐 들어있는지 확인
    }
  }

  try {
    const response = await authFetch(`${API_BASE_URL}/space/${spaceId}`, {
      method: 'PATCH',
      headers: {
        Authorization: `Bearer ${token}`,
      },
      body: dto, // dto는 완전한 FormData여야 함
    });

    if (!response.ok) throw new Error('Failed to update reservation.');
    return await response.json();
  } catch (error) {
    console.error('Error during fetch:', error);
    throw error;
  }
};

// 4. 실제 공간 업로드
export const uploadSpace = async (formData: FormData) => {
  const response = await authFetch(`${API_BASE_URL}/space/spaces`, {
    method: 'POST',
    body: formData,
  });

  if (!response.ok) {
    const errorData = await response.json();
    throw new Error(errorData.message || `Failed to upload space: ${response.status}`);
  }

  return response;
};


export async function fetchSpaceById(spaceId: string) {
  const res = await fetch(`${API_BASE_URL}/space/spaces/${spaceId}`, {
    method: 'GET',
    headers: { 'Content-Type': 'application/json' },
  });
  
  if (!res.ok) {
    const error = await res.text();
    console.error(error);
    return null; 
  }
  
    const space = await res.json();
    
    return space ? {
      id: space.id,
      description: space.description,
      ownerName: space.owner?.nickname || 'Unknown Owner',
      location: space.location,
      tags: space.tags?.map((tag: any) => tag.name) || [],
      reservationCount: space.reservations?.length || 0,
      rating: space.rating || 0,
      price: space.price_per_day,
      status: space.status,
      createdAt: space.created_at,
      updatedAt: space.updated_at,
      mainImageUrl : space.main_image || '', // 추가된 이미지 URL
      additionalImages: space.additional_images || [], // 추가된 이미지 배열
    } : null;
  }
  
  export async function fetchSpaces(params?: { 
    region?: string; 
    sort?: string; 
    page?: number; 
    limit?: number;
    buildingType?: string; 
  }) {
    const queryParams = new URLSearchParams(
      Object.entries(params || {}).reduce((acc, [key, value]) => {
        if (value !== undefined && value !== null) {
          acc[key] = String(value); // 숫자도 문자열로 변환
        }
        return acc;
      }, {} as Record<string, string>)
    ).toString();
  
    const res = await fetch(`${API_BASE_URL}/space/spaces${queryParams ? `?${queryParams}` : ''}`, {
      method: 'GET',
      headers: { 'Content-Type': 'application/json' },
    });
  
    if (!res.ok) {
      const error = await res.text();
      console.error(error);
      return { spaces: [], totalPages: 0, currentPage: 1 };
    }
  
    const data = await res.json();
  
    return {
      spaces: data.spaces.map((space: any) => ({
        id: space.id,
        ownerName: space.owner?.nickname || '',
        ownerCertified: space.owner?.is_certified || false,
        region: space.region || '',
        location: space.location,
        mainImageUrl: space.main_image || '',
        price: space.price_per_day,
        status: space.status,
        createdAt: space.created_at,
        updatedAt: space.updated_at,
        tags: space.tags?.map((tag: any) => tag.name) || [],
        reservationCount: space.reservations?.length || 0,
      })),
      totalPages: data.totalPages,
      currentPage: data.currentPage,
    };
  }
  

  export async function getAllSpaces() {
    const res = await fetch(`${API_BASE_URL}/space/spaces`, {
      method: 'GET',
      headers: { 'Content-Type': 'application/json' },
    });
  
    if (!res.ok) {
      const error = await res.text();
      console.error(error);
      return [];
    }
  
    const spaces = await res.json();

    return spaces.map((space: any) => ({
      id: space.id,
      ownerName: space.owner?.nickname || 'Unknown Owner',
      region: space.region.name,
      location: space.loacation,
      features: space.tags?.map((tag: any) => tag.name) || [],
      reservationCount: space.reservations?.length || 0,
      rating: space.rating || 0,
      price: space.price_per_day,
      status: space.status,
      createdAt: space.created_at,
      updatedAt: space.updated_at
    }));
  }

  export async function getUserSpaces() {
    const token = localStorage.getItem('user_token');

    const response = await authFetch(`${API_BASE_URL}/space/user/spaces`, {
        method: 'GET',
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || 'Failed to fetch spaces');
      }
      
      const data = await response.json();

      return data.map((space: any) => ({
        id: space.id,
        title : space.title,
        ownerName: space.owner?.email || 'Unknown Owner', 
        location: space.location,
        tags: space.tags?.map((tag: any) => tag.name) || ['No features'],
        reservationCount: space.reservations?.length || 0,
        rating: space.rating || 0,
        price: space.price_per_day,
        main_image: space.main_image || '',
      }));
  }

  export async function fetchMyItems() {
    const token = localStorage.getItem('user_token');

    const response = await authFetch(`${API_BASE_URL}/item/items`, {
        method: 'GET',
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || 'Failed to fetch items');
      }

      const data = await response.json();
      return data.items || [];
  };

  export async function getAllBuildingTypes() {
    const token = localStorage.getItem('user_token');

    const response = await authFetch(`${API_BASE_URL}/space/building-types`, {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.message || 'Failed to fetch building types');
    }

    const data = await response.json();
    return data || [];
  }